import React, { useState } from "react";
import "../styles/Blogs.css";
import { FaArrowRight, FaCalendar } from "react-icons/fa";
import SEO from "../components/SEO.js";
import { useNavigate } from "react-router-dom";
import blogsData from "../Data/blog_database.json";

const Blogs = () => {

  const [expandedBlog] = useState(null);

  const navigate = useNavigate();

  return (
    <section id="blogs" className="section scrollable">

      <SEO
        title="Best Imported Marble Buying Tips – Expert Guide by Square Feet Marble"
        description="Read expert tips about imported marble, design ideas, flooring guides, and the best marble trends in India."
        keywords="imported marble blog, Italian marble guide, Kishangarh marble trends, luxury marble ideas"
        canonical="https://squarefeetmarble.com/blog"
        ogImage="https://squarefeetmarble.com/assets/images/colllection.webp"
      />

      <div className="blogs-container">

        <div className="weekly-blogs">

          <div className="blog-section-divider">
            <h1 className="blog-section-title">
              Best Imported Marble Buying Tips – Expert Guide by Square Feet Marble
            </h1>
            <p className="blog-section-subtitle">
              CURATED MARBLE INSIGHTS
            </p>
          </div>

          <div className="weekly-blogs-grid">

            {[...blogsData]
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((blog, index) => (

                <div className="blog-card" key={blog.slug}>

                  <div
                    className="blog-card-image"
                    style={{
                      backgroundImage: `url(${blog.img})`
                    }}
                  >
                    <span className="blog-card-badge">
                      {blog.badge}
                    </span>
                  </div>

                  <div className="blog-card-content">

                    <h3>{blog.title}</h3>

                    <p>{blog.desc}</p>

                    <div className="blog-card-footer">

                      <span className="blog-date">
                        <FaCalendar /> {blog.date}
                      </span>

                      <a
                        href={`/blog/${blog.slug}/`}
                        className="blog-read-more"
                      >
                        Read More <FaArrowRight />
                      </a>

                    </div>

                  </div>

                </div>

              ))}

          </div>

        </div>

      </div>

    </section>
  );
};

export default Blogs;